import 'intersection-observer'
import $ from 'jquery'
import 'focus-visible'
import stickybits from 'stickybits'
import objectFitImages from 'object-fit-images'
import { getCookie, setCookie } from 'tiny-cookie'

import './plugins/collapse-or-expand-all'
import YoutubeContainer from './components/youtube-container'
import SiteAlert from './components/site-alert'
import CustomFileInput from './components/custom-file-input'
import Search from './components/search'
import FeedbackTabsAndForm from './components/feedback-tabs-and-form'
import FilterOverlay from './components/filter-overlay'
import Carousel from './components/carousel'
import Hero from './components/hero'
import InPageAnchors from './components/in-page-anchors'
import AnimationControl from './components/animation-control'
import SdGuide from './components/sd-guide'
import Slider from './components/slider'
import ExpandOnce from './components/expand-once'
import ScrollProgress from './components/scroll-progress'
import ScrollNav from './components/scroll-nav'
import ScrollFade from './components/scroll-fade'
import Sidetab from './components/sidetab'

// import CookiePrompter from './vendor/CookiePrompter'
// import CookieBanner from './components/cookie-banner'
import './vendor/modernizr-custom'

class PrototypeApp {
	constructor () {

		let isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
		let isSafari = (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1)

		if ( isIOS || isSafari ) $('html').addClass('is-safari')

		stickybits('[data-role="js--sticky"]', { useStickyClasses: true })

		objectFitImages();

		$('[data-role="js--site-alert"]').each((index, el) => {
			if (!el.id) {
				throw Error(`Site Alert must have a unique id - this is will be used as the cookie name.`)
			}
			if (!getCookie(el.id)) {
				new SiteAlert(el)
				$(el).on('alert-dismissed', event => setCookie(event.target.id, true, { expires: '1Y' }))
			}
		})

		$('[data-role="js--hero"]').each((index, el) => (new Hero(el)))
		$('[data-role="js--custom-file-input"]').each((index, el) => (new CustomFileInput(el)))
		$('[data-role="js--fold-all-in-out"]').collapseOrExpandAll()
		$('[data-role="js--youtube-container"]').each((index, el) => (new YoutubeContainer(el)))
		$('[data-role="js--search"]').each((index, el) => (new Search(el)))
		$('[data-role="js--filter-overlay"]').each((index, el) => (new FilterOverlay(el)))

		$('[data-role="js--carousel"]').each((index, el) => (new Carousel(el)))
		$('[data-role="js--expand-once"]').each((index, el) => (new ExpandOnce(el)))
		$('[data-role="js--scroll-progress"]').each((index, el) => (new ScrollProgress(el)))

		//Carousel alternative
		$('[data-role="js--slider"]').each((index, el) => (new Slider(el)))
		$('[data-role="js--in-page-anchor"]').each((index, el) => (new InPageAnchors(el, $('[data-role="js--scroll-nav"]').length > 0 ? 100 : 0)))
		$('[data-role="js--sidetab"]').each((index, el) => (new Sidetab(el)))


		window.onload = function(){
			new InPageAnchors(window, $('[data-role="js--scroll-nav"]').length > 0 ? 100 : 0, true);
		};

		$('[data-role="js--feedback"]').each((index, el) => (new FeedbackTabsAndForm(el)))

		$('[data-role="js--scroll-nav"]').each((index, el) => (new ScrollNav(el)))
		$('[data-role="js--scroll-fade"]').each((index, el) => (new ScrollFade(el)))
		$('[data-role="js--guide"]').each((index, el) => (new SdGuide(el)))

		let animationControl = new AnimationControl();

		$('#site-footer-links').on('shown.bs.collapse', function () {
			this.scrollIntoView( { behavior: 'smooth' } );

				/*
				IE Edge hack - slider inactive before a scroll has occured
				*/
				setTimeout(function() {
					try {
						var ci = $('.carousel__items')[0];
						ci.scrollLeft = 1;
					} catch(error) {}
				}, 50);

		});


		// -------- bootstrap popover's
		$('[data-toggle="popover"]')
			.popover({
				trigger: 'manual',
				placement: 'top',
				html: true
			})
			.on('mouseenter', function(e){ // desktop
				// test if it's the same popover-trigger
				if($(e.target).attr('aria-describedby') == undefined) { // "aria-describedby" is only set on active elements
					// close already open popover's
					if($('.popover').length > 0){
						$('body').trigger('click'); // trigger body click to close the active popover (via the body.click handler below)
						setTimeout(function(){
							$(e.currentTarget).popover('show');
						}, 150);
					} else {
						$(e.currentTarget).popover('show');
					}
				}
			})
			.on('touchstart', function(e){ // mobile
				// test if it's the same popover-trigger
				if($(e.target).attr('aria-describedby') == undefined) {
					// close already open popover's
					if($('.popover').length > 0){
						$('body').trigger('click');
						setTimeout(function(){
							$(e.currentTarget).popover('show');
						}, 150);
					} else {
						$(e.currentTarget).popover('show');
					}
				}
			})
			.on('keydown', function(e){ // tab and "enter"-press when focused
				// test if it's the same popover-trigger

				if(e.which == 13){
					if($(e.target).attr('aria-describedby') == undefined) {
						// close already open popover's
						if($('.popover').length > 0){
							$('body').trigger('click');
							setTimeout(function(){
								$(e.currentTarget).popover('show');
							}, 150);
						} else {
							$(e.currentTarget).popover('show');
						}
					}
				}
			});
		$(document).on('click', function (e) {
		    $('[data-toggle="popover"], .popover-close, [data-original-title]').each(function () {
		    	if($(e.target).hasClass('popover-close')){
		    		(($(this).popover('hide').data('bs.popover')||{}).inState||{}).click = false
		    	} else {
			        //the 'is' for buttons that trigger popups
			        //the 'has' for icons within a button that triggers a popup
			        if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
			            (($(this).popover('hide').data('bs.popover')||{}).inState||{}).click = false  // fix for BS 3.3.6
			        }
			    }

		    });
		});


		// JPL: No cookie banner – erst use CookiePrompter only

		// if (typeof CookieBanner !== 'undefined' && !getCookie('cookies-accepted') && !getCookie('cookies-declined')) {
		// 	const $cookieBanner = $('[data-role="js--cookie-banner"]').eq(0)
		// 	new CookieBanner($cookieBanner.get(0))

		// 	$cookieBanner.on('cookies-accepted', () => setCookie('cookies-accepted', true, { expires: '1Y' }))
		// 	$cookieBanner.on('cookies-declined', () => setCookie('cookies-declined', true, { expires: '1Y' }))
		// }



		// JPL: CookiePrompter js only in LBE solution

		// CookiePrompter.init({
		// 	trackers:[

		// 	],
		// 	readMoreUrl: '/home/about',
		// 	styling: {
		// 		cssclass:'minegenklasse'
		// 	}
		// });

	}
}

new PrototypeApp();
